import { Grid, Switch, Typography } from '@kc-console/common-ui';
import { useContextMenuPreferenceStore } from '@kc-console/context';
import { useTranslation } from '@kc-console/core';

import type { ChangeEvent } from 'react';

export const ContextMenuToggleItem = () => {
  const { t } = useTranslation();
  const enabled = useContextMenuPreferenceStore(state => state.enabled);
  const setEnabled = useContextMenuPreferenceStore(state => state.setEnabled);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEnabled(event.target.checked);
  };

  return (
    <Grid container flexDirection="row" justifyContent="space-between" alignItems="center">
      <Typography variant="label/regular/md">{t('layout:setting.context_menu.support')}</Typography>
      <Switch checked={enabled} onChange={handleChange} />
    </Grid>
  );
};
